import React, { useState, useEffect } from 'react';
import FormComponent from '../../../Reusable_Components/FormComponent';
import axios from 'axios';
import { API_ROUTES, API_DOMAIN, headers } from '../../../Reusable_Components/apiConfig';
import { useParams } from 'react-router-dom';

const AccountInput = () => {
  const { accountId = '' } = useParams();
  const decodedId = accountId ? atob(accountId) : accountId;
  const id = decodedId.replace(/\D/g, '');
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({});
  const [parentAccounts, setParentAccount] = useState([]);
  const route = 'account';

  useEffect(() => {
    if (accountId) {
      setIsEditing(true);
      fetchAccountDetails();
    }
    fetchExistingAccounts();
  }, [accountId]);

  const fetchAccountDetails = async () => {
    try {
      const response = await axios.get(`${API_DOMAIN}${API_ROUTES.account}${id}/`, { headers });
      const accountDetails = response.data;

      setFormData(accountDetails);
    } catch (error) {
      console.error('Error fetching account details:', error);
    }
  };

  const fetchExistingAccounts = async () => {
  try {
    const response = await axios.get(`${API_DOMAIN}${API_ROUTES.account}`, { headers });
    // const existingAccounts = response.data;
    const existingAccounts = response.data.map((account) => ({
        value: account.id,
        label: account.name,
      }));   



    setParentAccount(existingAccounts)

    return existingAccounts;
  } catch (error) {
    console.error('Error fetching existing accounts:', error);
    return [];
  }
};

  const accountFields = [
    { name: 'name', label: 'Account Name', type: 'text' },
    { name: 'code', label: 'Account Code', type: 'text' },
    {
      name: 'account_type',
      label: 'Account Type',
      type: 'select',
      options: [
        { value: 'ASSET', label: 'Asset' },
        { value: 'LIABILITY', label: 'Liability' },
        { value: 'EQUITY', label: 'Equity' },
        { value: 'REVENUE', label: 'Revenue' },
        { value: 'EXPENSE', label: 'Expense' },
      ],
    },
    {
      name: 'parent_account',
      label: 'Parent Account',
      type: 'select',
      options: parentAccounts,

    },
    { name: 'balance', label: 'Balance', type: 'number' },
  ];

  return (
    <div>
      <h1>{isEditing ? 'Edit Account' : 'Create Account'}</h1>
      <FormComponent fields={accountFields} initialFormData={formData} route={route} />
    </div>
  );
};

export default AccountInput;